export default __webpack_public_path__ + "static/media/person_icon.ed3cb92b.svg";